query ListBimClassesAssignedToCategory(
    $id: ID!
) {
    category(id: $id) {
        id

        bimClasses(tag: "latest") {
            id
            revisionID

            data {
                name(language: "en") {
                    text
                }
            }
        }
    }
}
